var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 79.999,
    viewBox: "0 0 80 79.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 299",
    d: "M222.33 1686.447a40 40 0 1 0 40 40 40.046 40.046 0 0 0-40-40z",
    transform: "translate(-182.327 -1686.447)",
    style: {
      fill: "#fd7121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 298",
    d: "M222.588 1709.552h-12.85V1696.7a2.142 2.142 0 1 0-4.283 0v12.85h-12.85a2.141 2.141 0 1 0 0 4.283h12.85v12.85a2.142 2.142 0 1 0 4.283 0v-12.85h12.85a2.141 2.141 0 1 0 0-4.283z",
    transform: "translate(-167.597 -1671.76)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularOrangeIcon);
export default __webpack_public_path__ + "static/media/circular-orange-icon.4a0449b67ea3e11b28e3452da5d99635.svg";
export { ForwardRef as ReactComponent };